export default {
  MEETING_API: 'https://stmmg9iap9.execute-api.us-east-1.amazonaws.com/conference',
  WSS: 'wss://mxdsdf5c3f.execute-api.us-east-1.amazonaws.com/conference',
  SIGNED_API: 'https://jbcl4wrbu6.execute-api.us-east-1.amazonaws.com/conference',
  STREAM_API: 'https://f68t1jfmu2.execute-api.us-east-1.amazonaws.com/conference',
  LOG_LEVEL: 'error',
  QUESTIONS_CF_API: 'https://d37l7zt1z6147j.cloudfront.net',
};
